import { styled } from '@lsy-netline/netline-ui';
import { MouseEvent, MouseEventHandler, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { OpenInNewIcon } from 'icons';
import { Popover } from 'netline-ui';

import styles, { anchorContextMenuClasses } from './AnchorContextMenu.styles';

const PopoverRoot = styled(Popover, { name: anchorContextMenuClasses.$name })(styles);

export type ContextMenuOptions = {
  anchorEl: Element | null;
  to?: string;
};

type AnchorContextMenuProps = {
  contextMenuOptions: ContextMenuOptions;
  onClose: MouseEventHandler<HTMLElement>;
};

const AnchorContextMenu = ({ contextMenuOptions, onClose }: AnchorContextMenuProps) => {
  const { t } = useTranslation();

  const { to, anchorEl } = contextMenuOptions;
  const handleClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      onClose(event);
    },
    [onClose],
  );

  return (
    <PopoverRoot
      id="AnchorContextMenu-root"
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      className={anchorContextMenuClasses.root}
    >
      <a
        href={`#${to}`}
        target="_blank"
        referrerPolicy="origin"
        onClick={handleClick}
        rel="noreferrer"
        className={anchorContextMenuClasses.link}
      >
        <div className={anchorContextMenuClasses.flexContainer}>
          <OpenInNewIcon className={anchorContextMenuClasses.icon} />
          <div>{t('contextMenu.text')}</div>
        </div>
      </a>
    </PopoverRoot>
  );
};

export default AnchorContextMenu;
